module.exports = __webpack_public_path__ + "static/media/star_shine.0409cd3b.webp";